import React from 'react';
import { Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = () => ({
    subtitle: {
        marginBottom: "20px",
        fontSize: "14px",
        color: "rgba(255, 255, 255, 0.7)"
    }
});

const ProgressSubtitle = ({ classes, receiveVideoNotificationEmails }) => {
    return (
        <Typography
            className={classes.subtitle}
            variant='subtitle1'
            component='p'
        >
            You may close this page and come back later. {receiveVideoNotificationEmails && 'We will email you when your export is finished.'}
        </Typography>
    );
}

export default withStyles(ProgressSubtitle, styles);

